import React from 'react'

import styles from './styles.module.scss'

const LoanTermModal = () => (
  <div className={styles.modalWrapper}>
    <p>
      <span className="bodySmall semiBold">Fixed-Rate Mortgage</span>
      <span className="neutral500 bodySmall">
        &nbsp; - A mortgage with an interest rate that does not change over the life of your loan.
        Your monthly mortgage payments will remain the same.
      </span>
    </p>
    <br />
    <p>
      <span className="bodySmall semiBold">Adjustable Rate Mortgage (ARM)</span>{' '}
      <span className="neutral500 bodySmall">
        &nbsp;- A mortgage with an interest rate that stays fixed for the first few years and then
        adjusts based on market conditions. For example, a 5/1 ARM has a rate that is fixed for the
        first 5 years, and the rate changes there after.{' '}
      </span>
    </p>
    <div className={styles.credibleTip}>
      <div className={styles.tipHeader}>
        <div className={styles.lightBlub} />
        <p className="bodySmall">
          <strong>Credible Tip</strong>
        </p>
      </div>
      <p className="neutral500 bodySmall">
        When it comes to mortgage terms, a fixed-rate mortgage is a lower risk choice because the
        interest rate remains the same over the duration of the term. An adjustable rate mortgage is
        considered riskier because the rate can increase or decrease based on the market.
      </p>
    </div>
  </div>
)

export default LoanTermModal
